/**
 * Stack routes of every native screen added by the admin-module groups.
 * Spread into the management stack by AppNavigator.
 */
import crm from './crm.routes';
import warehouse from './warehouse.routes';
import marketing from './marketing.routes';
import hr from './hr.routes';
import system from './system.routes';
import service from './service.routes';
import financeRoutes from './finance.routes';
import settingsRoutes from './settings.routes';
import developerRoutes from './developer.routes';
import usersRoutes from './users.routes';
import storecfgRoutes from './storecfg.routes';
import extras1Routes from './extras1.routes';
import extras2Routes from './extras2.routes';
import extras3Routes from './extras3.routes';

/** @type {Array<{name: string, component: React.ComponentType<any>}>} */
export const ADMIN_MODULE_ROUTES = [...crm, ...warehouse, ...marketing, ...hr, ...system, ...service, ...financeRoutes, ...settingsRoutes, ...developerRoutes, ...usersRoutes, ...storecfgRoutes, ...extras1Routes, ...extras2Routes, ...extras3Routes];

export default ADMIN_MODULE_ROUTES;
